import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import { DEPARTMENT_CONFIG_TYPE, LOAI_PHONG, TERM_CLASS_IDS } from '../../../../utils/Constant';
import EditableCell from './EditableCell';
import useDepartmentOptions from './hooks/useDepartmentOptions';

const Select = ({ setEnableEditing, updateRowData, row }: any) => {
	const rowData = row.original;

	const sampleDepartmentDefault = rowData?.attributes?.deptSamplingDeptCode
		? [
				{
					name: rowData?.attributes?.deptSamplingDeptName,
					value: rowData?.attributes?.deptSamplingDeptCode,
				},
		  ]
		: [];

	const sampleDepartmentConfigByTerm = rowData?.attributes?.deptSamplings
		? JSON.parse(rowData?.attributes?.deptSamplings).map((item: any) => ({
				name: item?.name,
				value: item?.code,
		  }))
		: [];

	const currentValue = rowData?.samplingDeptCode
		? [
				{
					name: rowData?.samplingDeptName,
					value: rowData?.samplingDeptCode,
				},
		  ]
		: [];

	const { departmentOptions } = useDepartmentOptions({
		defaultOptions: [
			...currentValue,
			...sampleDepartmentDefault,
			...sampleDepartmentConfigByTerm,
		],
		configType: LOAI_PHONG.LAY_MAU,
	});

	return (
		<AutocompleteV2
			autoFocus
			options={departmentOptions}
			value={currentValue}
			name="sampleDepartment"
			onChange={(selectedOption: any) => {
				updateRowData(row.index, "sampleDepartment", selectedOption);
				setEnableEditing(false);
			}}
			onBlur={() => {
				setEnableEditing(false);
			}}
		/>
	);
};

const SampleDepartmentCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData } = tableOptions;
	const rowData = row.original;
	const textValue = rowData?.samplingDeptName;

	return (
		<EditableCell
			disabled={rowData?.classId !== TERM_CLASS_IDS.XET_NGHIEM}
			editComponent={(props: any) => (
				<Select row={row} updateRowData={updateRowData} {...props} />
			)}
			textValue={textValue}
			className="spaces h-30 line-height-30"
		/>
	);
};

export default SampleDepartmentCell;
